import { render, staticRenderFns } from "./SearchOrderReturns.vue?vue&type=template&id=79c08066&"
import script from "./SearchOrderReturns.vue?vue&type=script&lang=js&"
export * from "./SearchOrderReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports